import { memo, useMemo } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useEvent } from 'core/hooks';

import { useQueryCurrentSettings } from 'features/api';

import { UserSettingsContext } from '../contexts';
import { UserSettingsContextType, UserSettingsProviderProps } from '../types';

export const UserSettingsProvider = memo<UserSettingsProviderProps>(({ children }) => {
  const queryClient = useQueryClient();
  const { data: userSettings } = useQueryCurrentSettings();

  const refreshSettings = useEvent(async () => {
    await queryClient.invalidateQueries({ queryKey: ['settings'] });
  });

  const context: UserSettingsContextType = useMemo(
    () =>
      userSettings == null
        ? {
            isInitialized: false,
            userSettings: null,
            refreshSettings,
          }
        : {
            isInitialized: true,
            userSettings,
            refreshSettings,
          },
    [userSettings, refreshSettings],
  );

  return <UserSettingsContext.Provider value={context}>{children}</UserSettingsContext.Provider>;
});

UserSettingsProvider.displayName = 'UserSettingsProvider';
